export default "__VITE_ASSET__bd48468a__"